import { proxy, useSnapshot } from "valtio";
export const $routeMetaStore = proxy({
    data: {},
});
export function useRouteMeta() {
    return useSnapshot($routeMetaStore, {
        sync: true,
    }).data;
}
